export type Flags =
  | "nftBridgeEnabled"
  | "walletExtendedActionsEnabled"
  | "shadowForkMessagesEnabled";

export type FeatureFlags = Record<Flags, boolean>;

import _featureFlags from "./config/featureFlags.json";
export const featureFlags: FeatureFlags = _featureFlags as FeatureFlags;

export const getFeatureFlagStatus = (flag: Flags) => featureFlags[flag];
